import script from "./MantenimientoFiscalTimbradosView.vue?vue&type=script&setup=true&lang=js"
export * from "./MantenimientoFiscalTimbradosView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__